/**
 * FileGetRes 类型和 Schema 定义
 *
 * ⚠️ 注意: 此文件由脚本自动生成，请勿手动修改
 * 如需更新，请运行代码生成脚本
 */
import type { SchemaDefinition } from './_schema'
import type { FileData } from './file_data'

/**
 * FileGetRes
 */
export interface FileGetRes {
  /** 文件详情列表 */
  items?: FileData[]
}

/**
 * FileGetRes Schema
 */
export const FileGetResSchema: SchemaDefinition = {
  properties: {
    items: {
      description: '文件详情列表',
      format: '[]*model.FileData',
      items: { $ref: 'FileData', description: '' },
      type: 'array',
      label: '文件详情列表',
    },
  },
  type: 'object',
}
